import * as tslib_1 from "tslib";
import Vue from 'vue';
import Router from 'vue-router';
import VueHtmlToPaper from 'vue-html-to-paper';
import App from './App.vue';
import store from './store';
import i18n from './config/i18n';
import axios from 'axios';
// // 引入自定义指令
// import directives from './directives';
import env from '@/config/env';
import routes from './routes';
import * as platform from '@cloudpivot/platform';
import './config/api';
import './config/antd';
import './styles/index.less';
let importReportService = false;
/**
 * 页面禁用拖拽上传时 浏览器默认打开图片
 */
document.addEventListener('drop', function (e) {
    e.preventDefault();
}, false);
document.addEventListener('dragover', function (e) {
    e.preventDefault();
}, false);
export function startup(environment) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        // 地址参数上携带access_token的，将token存在localstorage并清理地址上的参数
        if (environment && environment.T) {
            // 通过token获取refresh_token，实现token续期
            yield axios.post(`${env.oauthHost}/login/Authentication/get_refresh_token`, { access_token: environment.T }).then((res) => {
                if (res.errcode === 0 && res.data) {
                    const refresh_tokens = res.data.refresh_token;
                    let expireTime = res.data.expiration;
                    // 时间戳如果为13位则单位是ms,把单位转为s
                    if (expireTime.toString().length === 13) {
                        expireTime = expireTime.toString().slice(0, -3);
                    }
                    localStorage.setItem('refresh_token', refresh_tokens);
                    localStorage.setItem('expireTime', expireTime);
                }
            });
            //打开表单详情时不清理access_token, 原因为 解决钉钉打开流程表单点击同意后不关闭页面问题
            if (!window.location.href.includes('/form/detail?')) {
                const url = decodeURIComponent(window.location.href).replace('&T', 'T');
                window.location.href = url.replace(`T=${environment.T}`, '');
            }
        }
        window.Environment = environment;
        window.Environment.isIe = /Trident/.test(navigator.userAgent);
        Vue.config.productionTip = false;
        Vue.use(Router);
        Vue.use(VueHtmlToPaper);
        // 单应用路由
        if (window.Environment.appCode) {
            (routes[0]).redirect = '/app-home';
        }
        else if (window.Environment.messageId) {
            // 消息路由
        }
        const router = new Router({
            mode: 'history',
            base: process.env.BASE_URL,
            routes
        });
        Vue.prototype.router = router;
        router.beforeEach((to, from, next) => {
            let title = '快鱼';
            if (to.meta && to.meta.title) {
                title = to.meta.title;
            }
            platform.service.setTitle(title);
            if (to.name === 'appReport' && !importReportService) {
                importReportService = true;
                import('@/views/applications/report-service');
            }
            if (to.name === 'applicationReport' && !importReportService) {
                importReportService = true;
                import('@/views/applications/report-service');
            }
            if (to.name === 'applicationReport' && !importReportService) {
                importReportService = true;
                import('@/views/applications/report-service');
            }
            // weiyaos
            let t_expireTime = localStorage.getItem('expireTime');
            // 用户userId=990012312(必传)  是否隐藏导航栏IsNavigation=true||false（没有传默认为true true为隐藏）  入口entrance=ERP||POS||XXX（必传）
            //userId返回来时
            if (to.query.userId && to.query.entrance) {
                let IsNavigation = to.query.IsNavigation; //是否隐藏导航栏
                let userId = to.query.userId; //用户得userId
                let entrance = to.query.entrance; //入口  ERP||POS (ERP系统需要根据参数隐藏左侧菜单栏表栏目)
                if (entrance === 'ERP') {
                    sessionStorage.setItem('IsNavigation', IsNavigation);
                }
                let c_origin = location.origin;
                const token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
                // mao start
                if (token) {
                    localStorage.removeItem('token');
                }
                // mao end
                let url = `${c_origin}/api/public/organization/signOn?userId=${userId}`;
                axios.get(url).then((res) => {
                    if (res.code == 0) {
                        if (res.data.errcode === 0) {
                            localStorage.setItem('refresh_token', res.data.refresh_token);
                            localStorage.setItem('expireTime', res.data.expiration);
                            localStorage.setItem('token', res.data.access_token);
                            console.log('prePushnoTokenTo');
                            const refresh_token = localStorage.getItem('refresh_token');
                            console.log(refresh_token, 'refresh_token');
                            // 刷新token暂时不用
                            // const params = {
                            //     client_id: 'api',
                            //     client_secret: `${env.secret}`,
                            //     refresh_token,
                            // };
                            // console.log(params,'params')
                            const userInfoUrl = `${env.apiHost}/api/organization/user/info_login`;
                            axios.get(`${userInfoUrl}`, {
                                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                            }).then((res) => {
                                if (res.errcode === 0) {
                                    const info = res.data;
                                    sessionStorage.setItem('user', JSON.stringify(info));
                                    next();
                                    // console.log(`https://sso.avicnet.cn/sso/login?service=${encodeURIComponent(service)}`);
                                    // window.location.replace(service);
                                }
                            });
                            // axios.get(`https://aozhe-pre.fastfish.com/login/Authentication/get_refresh_token`, { params }).then((res: any) => {
                            //     // console.log(res);
                            //     if (res) {
                            //         const token = (res as any).access_token;
                            //         const refresh_tokens = (res as any).refresh_token;
                            //         const expireTime = (res as any).exp;
                            //         localStorage.setItem('refresh_token', refresh_tokens);
                            //         localStorage.setItem('expireTime', expireTime * 1000 + '');
                            //         localStorage.setItem('token', token);
                            //         const userInfoUrl = `${env.apiHost}/api/organization/user/info_login`;
                            //         axios.get(`${userInfoUrl}`, {
                            //             headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                            //         }).then((res: any) => {
                            //             if (res.errcode === 0) {
                            //                 const info: any = res.data;
                            //                 sessionStorage.setItem('user', JSON.stringify(info));
                            //                    next();
                            //                 // console.log(`https://sso.avicnet.cn/sso/login?service=${encodeURIComponent(service)}`);
                            //                 // window.location.replace(service);
                            //             }
                            //         })
                            //     }
                            // });
                        }
                    }
                    else {
                        console.log(' userId不存在');
                        window.alert(res.message);
                        window.close();
                    }
                });
                return;
            }
            // weiyaoe
            const token = localStorage.getItem('token');
            if (Vue.prototype.$httpRequestList.length > 0) { //强行中断时才向下执行
                Vue.prototype.$httpRequestList.forEach((item) => {
                    item('interrupt'); //给个标志，中断请求
                });
            }
            if (env.enableProxy) {
                next();
            }
            else {
                // document.title = to.meta.title;
                let locationUrlTrue = 'https%3A%2F%2Faozhe-pre.fastfish.com' /*'https%3A%2F%2Fjbpm.fastfish.com'*/; // 用于免登的地址，初始的域名
                if (!token && to.name !== 'login' && to.name !== 'oauth') {
                    // alert(JSON.stringify(to));
                    // window.location.href = '/login';
                    // next({ name: 'login' });   //  原逻辑，没有登陆信息的情况下去跳转到登录页 09.14
                    // 现在走keycloak登陆逻辑
                    const urlsearch = location.search;
                    const theRequest = new Object();
                    if (urlsearch.indexOf("?") !== -1) {
                        const str = urlsearch.substr(1);
                        const strs = str.split("&");
                        strs.forEach((res) => {
                            theRequest[res.split("=")[0]] = decodeURI(res.split("=")[1]);
                        });
                    }
                    if (theRequest.session_state && theRequest.code && theRequest.state) {
                        //拥有这三个参数的时候
                        // code state session_state
                        let locationUrl1 = localStorage.getItem("keycloak_redurl");
                        // @ts-ignore
                        axios.get(window.config.portalHost + '/api/login/Keycloak/ajax?code=' + theRequest.code + '&corpId=' + locationUrlTrue).then((res) => {
                            if (res.errcode == 0) {
                                localStorage.setItem("refresh_token", res.refresh_token);
                                localStorage.setItem("expireTime", res.expiration);
                                localStorage.setItem("token", res.access_token);
                                localStorage.setItem("keycloak_code", theRequest.code); // 存储keycloak的code，用于退出时使用
                                // location.href = location.origin + location.pathname; // 直接跳转页面
                                setTimeout(function () {
                                    location.href = 'https://aozhe-pre.fastfish.com'; // 免登后重新刷新页面，根据入口的页面刷新（基于待办）
                                }, 300);
                            }
                            else {
                            }
                        });
                    }
                    else {
                        // let locationUrl: any = locationUrlTrue;   // 用户后续接口回调用
                        // locationUrl = encodeURIComponent(locationUrl); // encode一下回调地址
                        localStorage.setItem("keycloak_redurl", locationUrlTrue); // 保存跳转时的回调地址
                        // @ts-ignore
                        let client_id_s = window.config.keycloak_id || 'aozhe-pro'; // 获取默认的client—id
                        // 延迟执行跳转
                        setTimeout(function () {
                            // @ts-ignore
                            location.href = 'https://sso.fastfish.com/realms/fastfish/protocol/openid-connect/auth?client_id=' + client_id_s + '&response_type=code&scope=openid&state=1&redirect_uri=' + locationUrlTrue;
                        }, 0);
                    }
                }
                else {
                    next();
                }
            }
        });
        // 全局注册自定义指令
        // Object.entries(directives).forEach((directive: any) => {
        //     const directiveName = directive[0];
        //     const directiveFunc = directive[1];
        //     Vue.directive(directiveName, directiveFunc);
        // });
        new Vue({
            router,
            i18n,
            store,
            render: (h) => h(App),
        }).$mount('#app');
    });
}
